










import { Component } from 'vue-property-decorator'
import { HsComponent } from '@hds/help-common/src/components/hs-components'
import uiEventBus, { UiState } from '@ustra/nuxt/src/vue/event-bus/global/ui-event-bus'
import { replace } from 'lodash'

@Component({})
/**
 * @vuese
 * @group component group
 * component description
 */
export default class extends HsComponent {
  // #region variables
  lastState: UiState = null
  title: string = null
  message: string = null
  action: any = null
  show: boolean = false

  get type() {
    if (!this.lastState || !this.lastState.type) {
      return 'alert'
    }

    return this.lastState.type
  }

  // #endregion
  // #region hooks
  mounted() {
    uiEventBus.on((state) => {
      if (state.type === 'alert' || state.type === 'confirm') {
        this.lastState = state
        this.show = true
        this.title = state.title
        this.message = state.msg ? replace(state.msg, '\n', '<br />') : state.msg
      }
    })
  }
  // #endregion

  // #region methods
  hide(result: boolean = true) {
    this.show = false

    if (this.lastState && this.lastState.action) {
      this.lastState.action(result)
    }
  }
  // #endregion
  // #region watches
  // #endregion
}
